import React from 'react';
import { classNames } from '@vkontakte/vkui';
import styles from './TextWithIcon.module.css';

interface TextWithIconProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  before?: React.ReactNode;
  after?: React.ReactNode;
  getRootRef?: React.RefObject<HTMLDivElement | null>;
  opticalCompensation?: boolean;
  align?: 'left' | 'center' | 'right';
  gap?: number;
}

/**
 * Универсальный компонент для инлайнового размещения иконки с текстом
 */
export function TextWithIcon(props: TextWithIconProps) {
  const {
    children,
    before,
    after,
    className,
    align,
    gap,
    opticalCompensation = true,
    getRootRef,
    style,
    ...restProps
  } = props;

  return (
    <div
      className={classNames(
        styles.root,
        align && styles[`root__align_${align}`],
        opticalCompensation && styles.root__optical_compensation,
        className,
      )}
      ref={getRootRef}
      style={{
        ...((gap !== undefined ? { '--text-with-icon-gap': `${gap}px` } : {}) as React.CSSProperties),
        ...style,
      }}
      {...restProps}
    >
      {before}
      <span className={styles.children}>{children}</span>
      {after}
    </div>
  );
}
